<template>
  <div>
    <template v-if="params.data._Ag_error_message">
      <Tooltip 
        transfer
        placement="right-start"
        max-width="300"
        :content="params.data._Ag_error_message">
        <span style="color: rgb(15, 142, 233);">{{ params.value }}</span>
        <i class="iconfont iconbj_listwarning ag-syman-hover" style="color: red;"></i>
      </Tooltip>
    </template>
    <template v-else>
      <span style="color: rgb(15, 142, 233);">{{ params.value }}</span>
    </template>
  </div>
</template>
<script>
export default {
  name: 'WarningTipRenderer',
  data() {
    return {}
  }
}
</script>